import React from 'react'
import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import Movieimagepresignedurl from '../../Services/Queries/Movieimagepresignedurl'
// import AwsConfig from '../../Config/AwsConfig'
import axios from 'axios'
import ImportMovie from '../../Services/Mutations/ImportMovie'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Auth } from 'aws-amplify'
export default function ImportMoviePerson() {
  const toastStyle = {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  const importTypes = [
    { label: 'Movies', value: 'movies' },
    { label: 'Person', value: 'person' },
    { label: 'Webseries', value: 'webseries' },
  ]
  const ref = React.useRef()

  const [selectedImportType, setSelectedImportType] = useState('')
  const [selectedFile, setSelectedFile] = useState(null)
  const handleImportTypeChange = value => {
    setSelectedImportType(value)
  }

  const handleSelectedFile = event => {
    setSelectedFile(event.target.files[0])
  }

  const handleUploadFile = async () => {
    const randomId = await uuidv4()
    let key = ''
    if (selectedImportType === 'movies') {
      key = 'public/importData/movies/' + randomId
    } else if (selectedImportType === 'person') {
      key = 'public/importData/persons/' + randomId
    } else {
      key = 'public/importData/webseries/' + randomId
    }

    // const key = 'public/movieData/movieImages/' + randomId + '.jpeg'
    const params = {
      key,
      mimeType: 'text/csv',
    }
    const preSignedURLObject = await Movieimagepresignedurl(params)
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
    const signedURL = signedURLObject.data.url
    try {
      const formData = new FormData()
      Object.keys(signedURLObject.data.fields).forEach(key => {
        formData.append(key, signedURLObject.data.fields[key])
      })
      // Actual file has to be appended last.
      formData.append('file', selectedFile)

      const response = await axios({
        method: 'post',
        url: signedURL,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      console.log(response)
      let loggedInUserHandle = ''
      const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
      if (loggedInUserEmail) {
        const emailParams = loggedInUserEmail.split('@')
        loggedInUserHandle = '@' + emailParams[0]
      }

      const importInput = {
        s3path: key,
        contentType: selectedImportType,
        moderatorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
        // moderatorID: 'dev',
        // moderatorHandle: 'devUser',
      }
      console.log(importInput)
      try {
        const importDataResponse = await ImportMovie(importInput)
        if (importDataResponse.statusCode === 'A009') {
          toast.success(importDataResponse.statusMessage, toastStyle)
          setSelectedFile(null)
          setSelectedImportType('')
          ref.current.value = ''
        } else {
          toast.error(importDataResponse.statusMessage, toastStyle)
        }
      } catch (error) {
        console.log(error)
      }

      // props.sendposterurl('poster1', posterUrl)
    } catch (err) {
      console.warn(err, 'err')
    }
  }

  const checkButtonDisabled = selectedImportType === '' || selectedFile === null
  return (
    <>
      <h4 className='mt-2'>Import Movies Or Persons Or Webseries</h4>
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className='d-flex mt-3'>
        {importTypes.map((importType, index) => (
          <div className='d-flex mr-3 justify-content-center align-items-center' key={index}>
            <input
              className='mr-1'
              type='radio'
              name='importType'
              value={importType.value}
              checked={selectedImportType === importType.value}
              onChange={() => handleImportTypeChange(importType.value)}
            />
            <span htmlFor='importType' onClick={() => handleImportTypeChange(importType.value)}>
              {importType.label}
            </span>
          </div>
        ))}
      </div>
      <div className='mb-3 mt-3 w-50'>
        <label htmlFor='formFile' className='form-label'>
          Choose File
        </label>
        <input
          ref={ref}
          onChange={handleSelectedFile}
          className='form-control'
          accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
          type='file'
          id='formFile'
        />
      </div>
      <button
        type='button'
        className='btn btn-primary'
        disabled={checkButtonDisabled}
        onClick={handleUploadFile}
      >
        Upload
      </button>
    </>
  )
}
